import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DiscountCoupon } from '../models/discount-coupon';


@Injectable()
export class DiscountService {

  getCouponDiscounts(
    coupons: string[],
    productIds: number[],
    prices: number[],
    quantities: number[],
    bookingDate: string,
    bookingFromTime: number,
    bookingToTime: number,
  ): Observable<DiscountCoupon[]> {
    throw new Error('Method not implemented.');
  }

  getGuestCouponDiscounts(
    coupons: string[],
    productIds: number[],
    prices: number[],
    quantities: number[],
    bookingDate: string,
    bookingFromTime: number,
    bookingToTime: number,
  ): Observable<DiscountCoupon[]> {
    throw new Error('Method not implemented.');
  }
}
